import { inject, Injectable } from '@angular/core';
import { forEach } from 'lodash-es';
import { isDefined } from '@wm/core';
import { getClonedObject, preventCachingOf, removeExtraSlashes } from '@wms/app/core';
import { WmApiMetaService } from '@wms/services';

@Injectable({
    providedIn: 'root'
})
export class BaseserviceService {

    wpApiMeta: any
    constructor() {
        this.wpApiMeta = inject(WmApiMetaService);
    }
    /* replace all the parameters from the config service*/
    parseReplace(serviceParams: any) {

        return new Promise<void>((resolve, reject) => {
            let val, param,
                config = this.wpApiMeta.metaFactory,
                urlParams = serviceParams.urlParams;

            /*get the config out of baseServiceManager*/
            if (config.hasOwnProperty(serviceParams.target) && config[serviceParams.target].hasOwnProperty(serviceParams.action)) {
                config = getClonedObject(config[serviceParams.target][serviceParams.action]);

                /*To handle dynamic urls, append the serviceParams.config.url with the static url(i.e., config.url)*/
                if (serviceParams.config) {
                    config.url = (serviceParams.config.url || "") + config.url;
                    config.method = serviceParams.config.method || config.method;
                    config.headers = config.headers || {};
                    forEach(serviceParams.config.headers, (val: any, key: any) => {
                        config.headers[key] = val;
                    });
                }
                /* check for url parameters to replace the url */
                if (urlParams) {
                    for (param in urlParams) {
                        if (urlParams.hasOwnProperty(param)) {
                            val = urlParams[param];
                            if (isDefined(val) && val !== null) {
                                //if the param is not present in the url, just add it to the URL or else replace the placeholder for the param value
                                if (config.url.indexOf(param) === -1) {
                                    config.url.indexOf("?") !== -1 ? config.url = config.url + "&" + param + "=" + val : config.url = config.url + "?" + param + "=" + val;
                                } else {
                                    config.url = config.url.replace(new RegExp(":" + param, "g"), val);
                                }
                            }
                        }
                    }
                }

                config.url = removeExtraSlashes(config.url);
                config.url = preventCachingOf(config.url);

                /* check for data */
                if (serviceParams.params) {
                    config.params = serviceParams.params;
                }
                /* check for data */
                if (isDefined(serviceParams.data)) {
                    config.data = serviceParams.data;
                }
                /* check for data parameters, written to support old service calls (.json calls) */
                if (serviceParams.dataParams) {
                    config.data.params = serviceParams.dataParams;
                }
                /* check for headers */
                if (serviceParams.headers) {
                    config.headers = serviceParams.headers;
                }

                /* set extra config flags */
                config.byPassResult = serviceParams.byPassResult;
                config.isDirectCall = serviceParams.isDirectCall;
                config.isExtURL = serviceParams.isExtURL;
                config.preventMultiple = serviceParams.preventMultiple;
                config.responseType = serviceParams.responseType;
                config.withCredentials = serviceParams.withCredentials;


                resolve(config);
            }

            resolve();
        });
    }
}
